export interface ReviewOption {
  title?: string;
  label?: string;
  description?: string;
  emoji?: string;
}
export type ReviewContentPart =
  | { type: 'text'; content: string }
  | { type: 'raw'; content: string }
  | { type: 'cards_list' | 'pills_list'; options: Array<ReviewOption>; content: string };

export function parseReviewContent(content: string): Array<ReviewContentPart> {
  const parts: Array<ReviewContentPart> = [];
  const pattern = /##start_ui_element[\s\S]*?(?:##end_ui_element|$)|#(?:start|end)_chat_response/g;
  let cursor = 0;
  for (const match of content.matchAll(pattern)) {
    if (match.index > cursor) {
      parts.push({ type: 'text', content: content.slice(cursor, match.index) });
    }
    const raw = match[0];
    let part: ReviewContentPart = { type: 'raw', content: raw };
    if (raw.startsWith('##start_ui_element') && raw.endsWith('##end_ui_element')) {
      try {
        const data = JSON.parse(raw.slice('##start_ui_element'.length, -'##end_ui_element'.length));
        // Model output uses question_type; customer-facing message parts normalise it to type.
        const componentType = data.type ?? data.question_type;
        if (
          (componentType === 'cards_list' || componentType === 'pills_list') &&
          Array.isArray(data.options) &&
          data.options.every(
            (option: ReviewOption) =>
              option &&
              typeof option[componentType === 'cards_list' ? 'title' : 'label'] === 'string' &&
              ['description', 'emoji'].every((key) => option[key] === undefined || typeof option[key] === 'string'),
          )
        ) {
          part = { type: componentType, options: data.options, content: raw };
        }
      } catch {
        /* Preserve malformed UI verbatim for debugging. */
      }
    }
    parts.push(part);
    cursor = match.index + raw.length;
  }
  if (cursor < content.length) {
    parts.push({ type: 'text', content: content.slice(cursor) });
  }
  return parts;
}
